import { RootState } from 'store';

export const authStateSelector = (state: RootState): boolean => !!state.auth.token;
export const authTokenSelector = (state: RootState): string => state.auth.token;
export const authErrorSelector = (state: RootState): boolean => state.auth.error;
export const authErrorTextSelector = (state: RootState): string => state.auth.errorText;
export const setPasswordTokenValiditySelector = (state: RootState): boolean => state.auth.setPasswordTokenValidity;

export const authLoadingSelector = (state: RootState): boolean => state.auth.loading;
